import { hc } from "hono/client";
import type { AppType } from "@jipraks/server/app-type";
import { authFetch } from "./auth-fetch";

/** Typed Hono RPC client (TECH.md §3.1). Session cookies ride along; 401s trigger one refresh. */
export const api = hc<AppType>(window.location.origin, { fetch: authFetch });
